export default __webpack_public_path__ + "static/media/messages.21869d51.svg";